import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/providers/shared/shared.service';

@Component({
  selector: 'app-componentes',
  templateUrl: './componentes.component.html',
  styles: [],
})
export class ComponentesComponent implements OnInit {
  
  constructor(private shared:SharedService) { }

  ngOnInit(): void {
  }

}
